(function ($) {
    'use strict';

    const popup = document.getElementById('atcp-popup');

    if (!popup || typeof addToCartPopup === 'undefined') {
        return;
    }

    const registerForm = document.getElementById('atcp-register-form');

    const loginForm = document.getElementById('atcp-login-form');

    const registerMessage = popup.querySelector('[data-atcp-register-message]');

    const loginMessage = popup.querySelector('[data-atcp-login-message]');

    const registerButton = popup.querySelector('[data-atcp-register-submit]');

    const loginButton = popup.querySelector('[data-atcp-login-submit]');

    const closeButton = popup.querySelector('[data-atcp-close]');

    const tabs = Array.from(popup.querySelectorAll('[data-atcp-tab]'));

    const panels = Array.from(popup.querySelectorAll('[data-atcp-panel]'));

    /**
     * Display the popup and move focus into the active form.
     */
    function openPopup() {
        if (popup.open) {
            return;
        }

        popup.showModal();

        const activePanel = popup.querySelector(
            '[data-atcp-panel]:not([hidden])'
        );

        const firstInput = activePanel?.querySelector('input');

        if (firstInput) {
            window.requestAnimationFrame(() => {
                firstInput.focus();
            });
        }
    }

    /**
     * Close the popup.
     */
    function closePopup() {
        if (popup.open) {
            popup.close();
        }
    }

    /**
     * Set an error message for a form.
     */
    function setMessage(element, message = '') {
        if (!element) {
            return;
        }

        element.textContent = message;
    }

    /**
     * Set the loading state of a submit button.
     */
    function setSubmitting(button, isSubmitting, submittingText) {
        if (!button) {
            return;
        }

        if (!button.dataset.originalText) {
            button.dataset.originalText = button.textContent.trim();
        }

        button.disabled = isSubmitting;
        button.setAttribute('aria-busy', isSubmitting ? 'true' : 'false');

        button.textContent = isSubmitting
            ? submittingText
            : button.dataset.originalText;
    }

    /**
     * Submit data to a WordPress AJAX action.
     */
    async function postForm(action, formData) {
        formData.append('action', action);
        formData.append('nonce', addToCartPopup.nonce);

        const response = await fetch(addToCartPopup.ajaxUrl, {
            method: 'POST',
            credentials: 'same-origin',
            body: formData,
        });

        let result;

        try {
            result = await response.json();
        } catch (error) {
            throw new Error('The server returned an invalid response.');
        }

        return result;
    }

    /**
     * Return a customer-facing message from an AJAX response.
     */
    function getResponseMessage(result, fallbackMessage) {
        if (result && result.data && typeof result.data.message === 'string') {
            return result.data.message;
        }

        return fallbackMessage;
    }

    /**
     * Verify that the redirect URL exists before redirecting.
     */
    function redirectToCart(result) {
        if (
            !result ||
            !result.data ||
            typeof result.data.redirectUrl !== 'string'
        ) {
            throw new Error('The server did not return a redirect URL.');
        }

        window.location.assign(result.data.redirectUrl);
    }

    /**
     * Check whether the latest added product should open the popup.
     */
    async function checkWhetherPopupShouldOpen() {
        const formData = new FormData();

        try {
            const result = await postForm('atcp_should_show_popup', formData);

            if (result.success && result.data && result.data.shouldShow) {
                openPopup();
            }
        } catch (error) {
            /*
             * Do not interrupt WooCommerce when checking the popup
             * condition fails.
             */
            console.error(
                'Failed to check whether the add-to-cart popup should open.',
                error
            );
        }
    }

    /**
     * Activate a registration or login tab.
     */
    function activateTab(tabName, focusPanel = false) {
        tabs.forEach((tab) => {
            const isActive = tab.dataset.atcpTab === tabName;

            tab.classList.toggle('is-active', isActive);
            tab.setAttribute('aria-selected', isActive ? 'true' : 'false');

            tab.tabIndex = isActive ? 0 : -1;
        });

        panels.forEach((panel) => {
            panel.hidden = panel.dataset.atcpPanel !== tabName;
        });

        setMessage(registerMessage);
        setMessage(loginMessage);

        if (!focusPanel) {
            return;
        }

        const activePanel = popup.querySelector(
            `[data-atcp-panel="${tabName}"]`
        );

        const firstInput = activePanel?.querySelector('input');

        if (firstInput) {
            firstInput.focus();
        }
    }

    /**
     * Move between tabs with the arrow keys.
     */
    function handleTabKeydown(event) {
        if (
            event.key !== 'ArrowLeft' &&
            event.key !== 'ArrowRight' &&
            event.key !== 'Home' &&
            event.key !== 'End'
        ) {
            return;
        }

        event.preventDefault();

        const currentIndex = tabs.indexOf(event.currentTarget);
        let nextIndex = currentIndex;

        if (event.key === 'ArrowRight') {
            nextIndex = (currentIndex + 1) % tabs.length;
        }

        if (event.key === 'ArrowLeft') {
            nextIndex = (currentIndex - 1 + tabs.length) % tabs.length;
        }

        if (event.key === 'Home') {
            nextIndex = 0;
        }

        if (event.key === 'End') {
            nextIndex = tabs.length - 1;
        }

        const nextTab = tabs[nextIndex];

        activateTab(nextTab.dataset.atcpTab);
        nextTab.focus();
    }

    const passwordToggles = Array.from(
        popup.querySelectorAll('[data-atcp-password-toggle]')
    );

    /**
     * Toggle password visibility.
     */
    function handlePasswordToggle(event) {
        const toggle = event.currentTarget;
        const inputId = toggle.getAttribute('aria-controls');
        const input = document.getElementById(inputId);

        if (!input) {
            return;
        }

        const shouldShowPassword = input.type === 'password';

        input.type = shouldShowPassword ? 'text' : 'password';

        toggle.setAttribute(
            'aria-pressed',
            shouldShowPassword ? 'true' : 'false'
        );

        toggle.setAttribute(
            'aria-label',
            shouldShowPassword ? 'Piilota salasana' : 'Näytä salasana'
        );
    }

    passwordToggles.forEach((toggle) => {
        toggle.addEventListener('click', handlePasswordToggle);
    });

    tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
            activateTab(tab.dataset.atcpTab, true);
        });

        tab.addEventListener('keydown', handleTabKeydown);
    });

    closeButton?.addEventListener('click', closePopup);

    popup.addEventListener('click', (event) => {
        /*
         * The dialog element itself represents the backdrop area.
         * Clicks inside the content container do not close it.
         */
        if (event.target === popup) {
            closePopup();
        }
    });

    registerForm?.addEventListener('submit', async (event) => {
        event.preventDefault();

        setMessage(registerMessage);

        if (!registerForm.checkValidity()) {
            registerForm.reportValidity();
            return;
        }

        const formData = new FormData(registerForm);
        const password = formData.get('password');
        const passwordConfirmation = formData.get('password_confirmation');

        if (password !== passwordConfirmation) {
            setMessage(registerMessage, 'Salasanat eivät täsmää.');

            document
                .getElementById('atcp-register-password-confirmation')
                ?.focus();

            return;
        }

        setSubmitting(registerButton, true, 'Luodaan käyttäjätiliä…');

        try {
            const result = await postForm('atcp_register_customer', formData);

            if (!result.success) {
                setMessage(
                    registerMessage,
                    getResponseMessage(
                        result,
                        'Käyttäjätilin luominen epäonnistui.'
                    )
                );

                return;
            }

            redirectToCart(result);
        } catch (error) {
            console.error('Customer registration request failed.', error);

            setMessage(
                registerMessage,
                'Käyttäjätilin luominen epäonnistui. ' + 'Yritä uudelleen.'
            );
        } finally {
            setSubmitting(registerButton, false, 'Luodaan käyttäjätiliä…');
        }
    });

    loginForm?.addEventListener('submit', async (event) => {
        event.preventDefault();

        setMessage(loginMessage);

        if (!loginForm.checkValidity()) {
            loginForm.reportValidity();
            return;
        }

        const formData = new FormData(loginForm);

        setSubmitting(loginButton, true, 'Kirjaudutaan…');

        try {
            const result = await postForm('atcp_login_customer', formData);

            if (!result.success) {
                setMessage(
                    loginMessage,
                    getResponseMessage(result, 'Kirjautuminen epäonnistui.')
                );

                return;
            }

            redirectToCart(result);
        } catch (error) {
            console.error('Customer login request failed.', error);

            setMessage(
                loginMessage,
                'Kirjautuminen epäonnistui. ' + 'Yritä uudelleen.'
            );
        } finally {
            setSubmitting(loginButton, false, 'Kirjaudutaan…');
        }
    });

    // Handle classic WooCommerce AJAX add-to-cart.
    $(document.body).on('added_to_cart', checkWhetherPopupShouldOpen);

    // Handle non-AJAX additions that caused a page reload.
    if (addToCartPopup.shouldOpen) {
        openPopup();
    }
})(jQuery);
